/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-meeting-label[_ngcontent-%COMP%]{line-height:30px}.ea-link[_ngcontent-%COMP%]{flex-grow:1}.ea-password[_ngcontent-%COMP%]{max-width:160px}"];
export { styles as styles };
